import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataAPI, postDataAPI, putDataAPI } from "../../utils/FetchData";
import { setErrorAlert, setLoader, setSuccessAlert } from "../alert/alertSlice";
import { get_file_order, get_folder_order, get_folder_thunk } from "../folder/folderThunk";
import { get_todo_order, get_todo_thunk } from "../todo/todoThunk";
import { clearTodos } from "../todo/todoSlice";
import { clearFolder } from "../folder/folderSlice";
import { setIsLogin } from "./authSlice";
import { get_opentabs_thunk } from "../opentab/opentabThunk";
import { clearOpenTabs } from "../opentab/opentabSlice";
import { clearShortcuts } from "../shortcut/shortcutSlice";
import { get_shortcut_thunk } from "../shortcut/shortcutThunk";

export const google_login_thunk = createAsyncThunk(
  "user/auth/google_login_user",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(setLoader(true));
      const google_login_thunk_res = await postDataAPI(
        "user/auth/google_login_user",
        tempData?.data,
        {}
      );
      thunkAPI.dispatch(setSuccessAlert(google_login_thunk_res?.data?.message));

      localStorage.setItem(
        "todoToken",
        JSON.stringify(google_login_thunk_res?.data?.data?.token)
      );
      localStorage.setItem(
        "todoUser",
        JSON.stringify(google_login_thunk_res?.data?.data?.response)
      );
      thunkAPI.dispatch(
        sync_data_thunk({ token: google_login_thunk_res?.data?.data?.token })
      );

      thunkAPI.dispatch(setLoader(false));
      return google_login_thunk_res.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
);

export const logout_thunk = createAsyncThunk(
  "auth/logout",
  async (tempData, thunkAPI) => {
    try {
      thunkAPI.dispatch(
        setIsLogin(null)
      )
      thunkAPI.dispatch(
        clearFolder()
      )
      thunkAPI.dispatch(
        clearTodos()
      )
      thunkAPI.dispatch(
        clearOpenTabs()
      )
      thunkAPI.dispatch(
        clearShortcuts()
      )
      localStorage.removeItem("todoToken");
      localStorage.removeItem("todoUser");
      localStorage.removeItem("folder");
      localStorage.removeItem("todos");
      localStorage.removeItem("openTabs");
      localStorage.removeItem("shortCuts");
      // If there's any specific Google data stored in localStorage, clear it as well
      localStorage.removeItem("googleOAuthToken");
      localStorage.removeItem("googleUserData"); // or whatever key you use to store user data

      // Optionally, if you are using Electron's API for Google OAuth, call the logout function (if available)
      if (window.electronAPI && window.electronAPI.logoutGoogle) {
        window.electronAPI.logoutGoogle(); // Clear any session or token on the Electron side
      }
      return;
      // window.location.href = "/";
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
);


export const sync_data_thunk = createAsyncThunk(
  "auth/sync_data",
  async (tempData, thunkAPI) => {
    try {

      thunkAPI.dispatch(
        get_folder_thunk({ token: tempData.token })
      );
      thunkAPI.dispatch(
        get_todo_thunk({ token: tempData.token })
      );
      thunkAPI.dispatch(
        get_opentabs_thunk({ token: tempData.token })
      );
      thunkAPI.dispatch(
        get_shortcut_thunk({ token: tempData.token })
      );
      thunkAPI.dispatch(
        get_user_thunk({ token: tempData.token })
      );
      thunkAPI.dispatch(
        get_folder_order({ token: tempData.token })
      );
      thunkAPI.dispatch(
        get_file_order({ token: tempData.token })
      );
      thunkAPI.dispatch(
        get_todo_order({ token: tempData.token })
      );
      return;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
)

export const get_user_thunk = createAsyncThunk(
  "user/auth/get_user",
  async (tempData, thunkAPI) => {
    try {
      const get_user_thunk_res = await getDataAPI(
        "user/auth/get_user",
        tempData.token
      );
      return get_user_thunk_res.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
)

export const update_user_thunk = createAsyncThunk(
  "user/auth/update_user",
  async (tempData, thunkAPI) => {
    try {
      const update_user_thunk_res = await putDataAPI(
        "user/auth/update_user",
        tempData?.data,
        tempData.token
      );
      return update_user_thunk_res.data;
    } catch (error) {
      console.log("error", error);
      thunkAPI.dispatch(
        setErrorAlert(error?.response?.data?.message || "Your network is offline")
      );
      return thunkAPI.rejectWithValue(
        error?.response?.data?.message || "The data is not stored because your network is offline"
      );
    }
  }
)